var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("div", { staticClass: "card" }, [
        _vm.refundSearch
          ? _c("div", { staticClass: "card-header" }, [
              _c("h5", { staticClass: "color_dark_red" }, [
                _vm._v("Поиск завки для возврата"),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c(
            "form",
            {
              attrs: { action: "" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.searchOrders.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-4" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Текст для поиска"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.search.searchData,
                          expression: "search.searchData",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        placeholder: "Номер заявки, препарат...",
                      },
                      domProps: { value: _vm.search.searchData },
                      on: {
                        keyup: _vm.updateSearchOptions,
                        change: _vm.updateSearchOptions,
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.search,
                            "searchData",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4" }, [
                  _vm.cities.length
                    ? _c(
                        "div",
                        { staticClass: "form-group cities_select" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Выберите город"),
                          ]),
                          _vm._v(" "),
                          _c("SelectCity", {
                            attrs: {
                              updateSelectedCity: (cities) =>
                                (_vm.search.cities = cities),
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cities.length
                    ? _c("div", { staticClass: "form-group cities_select" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.search.division,
                                expression: "search.division",
                              },
                            ],
                            staticClass: "form-control",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.search,
                                  "division",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c("option", { domProps: { value: 0 } }, [
                              _vm._v("Любой дивизион"),
                            ]),
                            _vm._v(" "),
                            _vm._l(
                              _vm.sortArray(_vm.$AllDivisions, "title"),
                              function (d) {
                                return d.is_active
                                  ? _c(
                                      "option",
                                      { domProps: { value: d.id } },
                                      [
                                        _vm._v(
                                          _vm._s(d.title) + "\n                "
                                        ),
                                      ]
                                    )
                                  : _vm._e()
                              }
                            ),
                          ],
                          2
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("div", { staticClass: "form-group date_range" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Период поиска"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "input-group" },
                      [
                        _c("datetime", {
                          attrs: {
                            "input-class": "form-control",
                            type: "date",
                            "minute-step": 60,
                            format: "dd.MM.yyyy",
                            auto: true,
                          },
                          model: {
                            value: _vm.search.range.start,
                            callback: function ($$v) {
                              _vm.$set(_vm.search.range, "start", $$v)
                            },
                            expression: "search.range.start",
                          },
                        }),
                        _vm._v(" "),
                        _vm._m(0),
                        _vm._v(" "),
                        _c("datetime", {
                          attrs: {
                            "input-class": "form-control",
                            type: "date",
                            "minute-step": 60,
                            format: "dd.MM.yyyy",
                            auto: true,
                          },
                          model: {
                            value: _vm.search.range.end,
                            callback: function ($$v) {
                              _vm.$set(_vm.search.range, "end", $$v)
                            },
                            expression: "search.range.end",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-group search_types" },
                    _vm._l(_vm.searchOptionsFiltered, function (opt, index) {
                      return _c("div", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.search.searchType,
                              expression: "search.searchType",
                            },
                          ],
                          attrs: { type: "radio", id: `inlineRadio${index}` },
                          domProps: {
                            value: opt.value,
                            checked: _vm._q(_vm.search.searchType, opt.value),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$set(
                                _vm.search,
                                "searchType",
                                opt.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label",
                            attrs: { for: `inlineRadio${index}` },
                          },
                          [_vm._v(_vm._s(opt.title))]
                        ),
                      ])
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-4" },
                  [
                    _c("CustomMultiSelect", {
                      ref: "selectedStatuses",
                      attrs: {
                        records: _vm.orderStatuses,
                        options: { placeholder: "Выберите статус заявки" },
                      },
                    }),
                    _vm._v(" "),
                    _vm.search.showCardPrePaid
                      ? _c(
                          "div",
                          { staticClass: "mt-2" },
                          [
                            _c("multiselect", {
                              attrs: {
                                options: _vm.getCreditCards(),
                                "track-by": "title",
                                label: "title",
                                "show-labels": false,
                                placeholder: "Выберите карту",
                                multiple: true,
                              },
                              model: {
                                value: _vm.search.selectedCreditCards,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.search,
                                    "selectedCreditCards",
                                    $$v
                                  )
                                },
                                expression: "search.selectedCreditCards",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4" }, [
                  !_vm.refundSearch
                    ? _c(
                        "div",
                        { staticClass: "form-check m-r-20 text-left" },
                        [
                          _c(
                            "div",
                            { class: { opacity: _vm.search.closedOnly } },
                            [
                              _c("div", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.search.showCardPrePaid,
                                      expression: "search.showCardPrePaid",
                                    },
                                  ],
                                  staticClass: "form-check-input",
                                  attrs: {
                                    type: "checkbox",
                                    id: "gridCheck11",
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.search.showCardPrePaid
                                    )
                                      ? _vm._i(
                                          _vm.search.showCardPrePaid,
                                          null
                                        ) > -1
                                      : _vm.search.showCardPrePaid,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.search.showCardPrePaid,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.search,
                                              "showCardPrePaid",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.search,
                                              "showCardPrePaid",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.search,
                                          "showCardPrePaid",
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-check-label",
                                    attrs: { for: "gridCheck11" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    Заявки с предоплатой\n                  "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.search.showRejected,
                                      expression: "search.showRejected",
                                    },
                                  ],
                                  staticClass: "form-check-input",
                                  attrs: { type: "checkbox", id: "gridCheck1" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.search.showRejected
                                    )
                                      ? _vm._i(_vm.search.showRejected, null) >
                                        -1
                                      : _vm.search.showRejected,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.search.showRejected,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.search,
                                              "showRejected",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.search,
                                              "showRejected",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.search,
                                          "showRejected",
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-check-label",
                                    attrs: { for: "gridCheck1" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    Показывать также отмененные заявки\n                  "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.search.showClosed,
                                      expression: "search.showClosed",
                                    },
                                  ],
                                  staticClass: "form-check-input",
                                  attrs: { type: "checkbox", id: "gridCheck2" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.search.showClosed
                                    )
                                      ? _vm._i(_vm.search.showClosed, null) > -1
                                      : _vm.search.showClosed,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.search.showClosed,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.search,
                                              "showClosed",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.search,
                                              "showClosed",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.search, "showClosed", $$c)
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-check-label",
                                    attrs: { for: "gridCheck2" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    Показывать также выполненные\n                  "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.search.myProjects,
                                      expression: "search.myProjects",
                                    },
                                  ],
                                  staticClass: "form-check-input",
                                  attrs: { type: "checkbox", id: "gridCheck3" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.search.myProjects
                                    )
                                      ? _vm._i(_vm.search.myProjects, null) > -1
                                      : _vm.search.myProjects,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.search.myProjects,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.search,
                                              "myProjects",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.search,
                                              "myProjects",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.search, "myProjects", $$c)
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-check-label",
                                    attrs: { for: "gridCheck3" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    Искать только по моим проектам\n                  "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.search.closedOnly,
                                  expression: "search.closedOnly",
                                },
                              ],
                              staticClass: "form-check-input",
                              attrs: { type: "checkbox", id: "gridCheck4" },
                              domProps: {
                                checked: Array.isArray(_vm.search.closedOnly)
                                  ? _vm._i(_vm.search.closedOnly, null) > -1
                                  : _vm.search.closedOnly,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.search.closedOnly,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.search,
                                          "closedOnly",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.search,
                                          "closedOnly",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.search, "closedOnly", $$c)
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label",
                                attrs: { for: "gridCheck4" },
                              },
                              [
                                _vm._v(
                                  "\n                  Искать только закрытые заявки\n                "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.search.closedOnly
                            ? _c("div", [
                                _c("div", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.search.reportDate,
                                        expression: "search.reportDate",
                                      },
                                    ],
                                    staticClass: "form-check-input",
                                    attrs: {
                                      type: "checkbox",
                                      id: "gridCheck5",
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.search.reportDate
                                      )
                                        ? _vm._i(_vm.search.reportDate, null) >
                                          -1
                                        : _vm.search.reportDate,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.search.reportDate,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.search,
                                                "reportDate",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.search,
                                                "reportDate",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.search,
                                            "reportDate",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "form-check-label",
                                      attrs: { for: "gridCheck5" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    Поиск по дате закрытия заявки\n                  "
                                      ),
                                    ]
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-right" },
                [
                  _c(
                    "vue-ladda",
                    {
                      attrs: {
                        type: "submit",
                        "button-class": "btn btn-success",
                        "data-style": "zoom-in",
                        loading: _vm.btnLoading,
                      },
                    },
                    [_vm._v("Поиск\n          ")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.showSearchResult && !_vm.orders && !_vm.searchLoading
        ? _c("div", { staticClass: "alert alert-warning" }, [
            _c("p", [_vm._v("Заявок не найдено")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.orders || _vm.searchLoading
        ? _c("div", { staticClass: "card" }, [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("pulse-loader", {
                  staticClass: "text-center",
                  attrs: {
                    loading: _vm.searchLoading,
                    color: _vm.loadingColor,
                  },
                }),
                _vm._v(" "),
                _vm.orders
                  ? _c("ordersList", {
                      attrs: {
                        orders: _vm.orders,
                        projects: _vm.projects,
                        cities: _vm.citiesMapped,
                        subStatuses: _vm.subStatuses,
                        displayType: _vm.refundSearch ? "refund" : "natural",
                        sitesToEdit: _vm.sitesToEdit,
                        openModal: _vm.modalRefundOrder,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-right pagination_div" },
                  [
                    _vm.paginator
                      ? _c("paginate", {
                          attrs: {
                            "page-count": _vm.paginator.last_page,
                            "page-range": 8,
                            "margin-pages": 2,
                            "click-handler": _vm.searchOrders,
                            "prev-text": "&laquo",
                            "next-text": "&raquo",
                            "container-class": "pagination",
                            "prev-class": "page-item",
                            "prev-link-class": "page-link",
                            "page-class": "page-item",
                            "page-link-class": "page-link",
                            "next-class": "page-item",
                            "next-link-class": "page-link",
                            "active-class": "active green_btn",
                          },
                          model: {
                            value: _vm.currentPage,
                            callback: function ($$v) {
                              _vm.currentPage = $$v
                            },
                            expression: "currentPage",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.orders ? _c("div", { staticClass: "card" }, [_vm._m(1)]) : _vm._e(),
      _vm._v(" "),
      _vm.modalData
        ? _c("customModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.modalData,
                expression: "modalData",
              },
            ],
            attrs: {
              onModalClose: _vm.onModalClose,
              onModalAccept: _vm.createRefundOrder,
              modalData: _vm.modalData,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "input-group-prepend input-group-append" },
      [_c("span", { staticClass: "input-group-text" }, [_vm._v("по")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "alert alert-info order_legend" }, [
        _c("p", [
          _vm._v(
            "* В поле дата находится следующая информация (в зависимости от статуса):"
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Введена вручную, обработана менеджером - указанная менеджером дата доставки (планированная)"
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Доставлена, закрыта, Отказ у менеджера, отказ у курьера Отказ у менеджера, отказ у курьера - report date\n          (дата получения финального статуса)"
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }